import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';
import { AccountService } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { InsuranceService } from '../Services/insurance.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-insurance-assistance',
  templateUrl: './insurance-assistance.component.html',
  standalone:false,
  styleUrls: ['./insurance-assistance.component.scss']
})
export class InsuranceAssistanceComponent implements OnInit {
  proposalId: string;
  Assitantlist: any;

  constructor(private router: Router,private acct:AccountService, private insurance:InsuranceService,private _sanitizer: DomSanitizer, private common: CommonService,    private cookieService: CookieService,
    public auth:AuthService) {}
    
 async  ngOnInit(): Promise<any> {

  this.common.presentLoading();
  this.auth.accessToken = await this.common.Get("token");
  
  this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
    if (data?.response?.code == 1) {
      this.insurance.GetAssistanceList(this.proposalId,this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {
        this.Assitantlist = res.response.content;


        this.Assitantlist.forEach(element => {

          element.icon = this._sanitizer.bypassSecurityTrustResourceUrl("data:image/svg+xml;base64,"+element.icon);

        });

        console.log("this.Assitantlist", this.Assitantlist);
        this.common.hideLoading();
        this.cookieService.delete("proposalId");

      }
      else {

        this.common.hideLoading();
        this.common.ParseErrorAlert("", "OK", this.router, res);
      }
    })
  }
  else {
    await this.common.hideLoading();
    this.common.ParseErrorAlert("", "", this.router, data);
  }

  })
    let a =await this.cookieService.get("proposalId", false);

    if (a) {

      this.proposalId = a;

    }
   
    
  }

}
